var _style, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivat24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#8DC641;}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.9861,
    y1: 546.3096,
    x2: 462.9861,
    y2: 110.3096,
    gradientTransform: "matrix(1 0 0 -1 0 602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 303,
    cy: 299,
    r: 264
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300,13C141.5,13,13,141.5,13,300s128.5,287,287,287s287-128.5,287-287S458.5,13,300,13z M300,555.4 C158.9,555.4,44.6,441.1,44.6,300S158.9,44.6,300,44.6S555.4,158.9,555.4,300S441.1,555.4,300,555.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M400.2,234.8l-64,94.9h64V234.8z M424.5,196.4v133.3h28.1v24.1h-28.1v49.8h-24.3v-49.8h-90.4v-26L401,196.4 H424.5z M282.9,379.4v24.2H147.4v-0.7c1.3-22.7,7.2-39.3,18.4-53c9.2-11.3,20.3-19.8,43.2-34.1c-0.1,0,8.1-5.1,10.4-6.6 c12.3-7.9,20.2-14,26.4-21.2c7.8-9.1,11.9-19,11.9-30.6c0-22.6-16-38.2-39.1-38.2c-26.8,0-40.6,20.4-41.4,51.1v0.6h-24.1v-0.6 l-0.3-5.6c0-41,26.7-68.3,66.9-68.3c39.3,0,64.9,23.8,64.9,60.5c0,18.7-6.7,33.9-19.6,47.4c-9.7,10.1-19.7,17-42.3,30.7 c-0.3,0.2-0.6,0.4-0.9,0.6c-1.1,0.6-6,3.5-7.3,4.3c-10.8,6.5-17.3,11-23.1,16.5c-7.1,6.8-11.8,14.2-14,23L282.9,379.4L282.9,379.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivat24);
export default __webpack_public_path__ + "static/media/privat24.7948f829aca6b3751feee39080494596.svg";
export { ForwardRef as ReactComponent };